export default "__VITE_ASSET__BQZwl$kF__"